function init_firsttimelogin () {
	bindEditButtons();
	bindCancelButtons();
	bindSubmitButtons();
	bindPersonalQuestionSelect();
	bindEmailAddress();
	bindTextAreaCounter();
	bindSummaryElements();
	validateNewPassword();
	bindSummaryEmailAddress();
	bindLanguageSelect();
	
	onFirstTimeLoginOverviewSubmit();
	onFirstTimeLoginSubmit();
		
	$('input[name=correspondence]').change(function(){
		var value = $('input[name=correspondence]:checked').val();
		var zeNextStep = '';
		if(value == 'email') zeNextStep = '4b';
		if(value == 'post') zeNextStep = '4c';
		
		$(this).closest('form').attr('data-nextstep',zeNextStep);
	});
	
	changeStep(1);
} 

function validateNewPassword(){
    $('input[name=newPassword], input[name=summaryEditPassword]').change(function(){
		var password = $(this).val();
		var fieldInstance = $(this).parsley();
		validatePassword('/web/nniprestserviceservlet/validatePassword', password, fieldInstance, 'newPassword-custom');
    });		
}

function validatePassword(url, password, fieldInstance, errorName) {
	//TODO: Merge with same call done in formFragmentPasswordIndicatorInput.jspf

	if (password != '' && password != null) {
		fieldInstance.removeError(errorName);

		//Append loader span
		$(fieldInstance.$element[0]).parent().addClass('wrapper').append('<span class="fetching-data"></span>');
		$(fieldInstance.$element[0]).parents('form').find("[type='submit']").prop('disabled', true);

		$.ajax({
			type: "POST",
			url: url,
			data: password,
			contentType: "application/json;",
			success: function (data) {
				//Remove remove loader span
				$(fieldInstance.$element[0]).parent().find(".fetching-data").remove();
				$(fieldInstance.$element[0]).parents('form').find("[type='submit']").prop('disabled', false);

				if(data.length) {
					var jsonData = JSON.parse(data);
					$.each(jsonData, function (i, value) {
						switch(value) {
							case "project.error_password_invalid_weak_password":
							case "project.validation_passwordstrength":
								value = jsLanguageLabel.error_password_invalid_weak_password;
							break;
							case "project.error_password_not_correct":
								value = jsLanguageLabel.error_password_not_correct; 
							break;
							case "project.error_password_invalid_password_used":
								value = jsLanguageLabel.error_password_invalid_password_used;
							break;
							case "project.error_password_invalid_repeating_password":
								value = jsLanguageLabel.error_password_invalid_repeating_password;
							break;
							case "project.error_password_invalid_common_password":
								value = jsLanguageLabel.error_password_invalid_common_password;
							break;
							case "project.error_password_invalid_sameasusername":
								value = jsLanguageLabel.error_password_invalid_sameasusername;
							break;
						}
						fieldInstance.addError(errorName, { message: value, });
					});
				}
			}
		});
		
	}

}

function bindEditButtons(){
	$('.btn.edit').click(function(){
		// Add class to surrounding div
		$(this).closest('.editform').addClass('openform');
		
		// Close all other open forms
		var $openforms = $('.form.opened .default');
		$openforms.slideUp(200, function() {
			$(this).closest('.form.opened').removeClass('opened');
		});
		
		// Now open this form
		var $form = $(this).closest('.form');
		$form.addClass('opened');
		$form.find('.default').slideDown(200, function(){
			// Do n'thing, just leaving this here for future s'mthings.
		});
		
		return false;
	});
}

function bindCancelButtons(){
	$('.btn.cancel').click(function(){
		// Remove class to surrounding div
		$(this).closest('.editform').removeClass('openform');
		
		var $form = $(this).closest('.form');
		$form.find('.default').slideUp(200, function(){
			$(this).closest('.form').removeClass('opened');
		});
		
		return false;
	});
}

function bindSubmitButtons(){
	$('.btn.cancel').next().find('input[type=submit]').click(function(e){
		e.preventDefault();

		// Validate this baby
		var $form = $(this).closest('form');
		$form.parsley().validate();
		var parsleyValid = $form.parsley().isValid();
		if (parsleyValid) {
			$form.submit();
			
			// Done, let's wrap this up
			$(this).closest('.editform').removeClass('openform');
			$form.find('.default').slideUp(200, function(){
				$form.removeClass('opened');
			});
		}
		
		return false;
	});
}

function bindLanguageSelect(){
	$("select[name='language']").change(function(){
		if($("select[name='language']").val() !=' ') $("#taal").parsley().reset();;
	});
}


function bindPersonalQuestionSelect(){
	$("select[name='personalQuestion'],select[name='summaryEditPersonalQuestion']").change(function(){
		if($(this).val() == '0'){
			 $(this).closest('.item').next().show();
			 $('#eigenvraag,#summaryEditPersonalQuestionOwn').prop('required',true);
			 $('textarea#eigenvraag').parsley().reset();
			 $('textarea#summaryEditPersonalQuestionOwn').parsley().reset();
			 
		}else {
		    	$('textarea#eigenvraag').val('');
			$('textarea#summaryEditPersonalQuestionOwn').val('');
		    	$('#eigenvraag, #summaryEditPersonalQuestionOwn').prop('required',false);
		    	$('textarea#eigenvraag').parsley().destroy();
			$('textarea#summaryEditPersonalQuestionOwn').parsley().destroy();
			$(this).closest('.item').next().hide();
		}
		if($("select[name='personalQuestion']").val() !=' ') $("#vraag").parsley().reset();
	});
}

function bindEmailAddress(){
	$("#email11,#email22").change(function(){
	    var emailVal = $("#email11").val();
	    if(emailVal!=undefined && emailVal!=''){
		$('#email22').prop('required',true);
	    };
	});
}

function bindSummaryEmailAddress(){
	$("#summaryEditEmail1,#summaryEditEmail2").change(function(){
	    var emailVal = $("#summaryEditEmail1").val();
	    $("#summaryEmail").val();
	    var correspondence = $("input[name=summaryEditCorrespondence]:checked").val();
	    if(correspondence =='email') {
		$('#summaryEditEmail1').prop('required',true);
	    }else{
		$('#summaryEditEmail1').prop('required',false);
	    }
	    if(emailVal!=undefined && emailVal!=''){
		$('#summaryEditEmail2').prop('required',true);
	    }else{
		$('#summaryEditEmail2').prop('required',false);
	    }
	});
}


function bindSummaryElements(){
	$("input[name=summaryEditCorrespondence]").click(function(){
		if($(this).val() == 'post'){
			$('#removeMailForm').show();
			$('input[name=ftl_removeemail]').val($('select[name=removeEmail]').val());
		}else{
			$('#removeMailForm').hide();
		}
	});
	
	
	$('select[name=removeEmail]').change(function(){
		$('input[name=ftl_removeemail]').val($(this).val());
		if($('select[name=removeEmail]').val() =='1') {
		    $('input[name=summaryEmail').val('');
		    $('input[name=summaryEditEmail1').val('');
		    $('input[name=summaryEditEmail2').val('');
		    $('input[name=ftl_email').val('');		    
		}else{
		    $('input[name=ftl_email').val($('#email1').val());
		}
	});
}

function bindTextAreaCounter(){
	$('.charcount').on('keyup',function(){
		var text = $(this).val();
		if(text.length > 100) $(this).val(text.substring(1, 100));
		
		$('.chars span').html(100 - $(this).val().length);
	});
}

function onFirstTimeLoginSubmit(){
	$('.epform:not(.summaryform)').on('submit', function(e) {
	    	
		e.preventDefault();
		
		var gateOpen = true;
		
		// Check if the password field still has errors. The normal parsley().isValid() does not cover this check as it's an external validator. Parsley sucks.
		var $passwordInput = $('#newPassword');
		var $currentpasswordInput = $('#currentPassword');
		if($passwordInput.next().find('p.warning').length > 0){
			$passwordInput.removeClass('parsley-success').addClass('parsley-error');
			gateOpen = false;
		}
		
		if($currentpasswordInput.next().find('p.warning').length > 0) {
		    $currentpasswordInput.removeClass('parsley-success').addClass('parsley-error');
		    gateOpen = false;
		}
		
		var emailVal = $("#summaryEditEmail1").val();
		var emailVal2 = $("#summaryEditEmail2").val();
		var correspondence = $("input[name=summaryEditCorrespondence]:checked").val();
		if($(this).attr('data-nextstep') === undefined && correspondence == 'email' && (emailVal =='' || emailVal2 =='') ){
		    $('#editemail').addClass('opened');
		    $('#editemail').closest('.editform').addClass('openform');
		    $("#summaryEditEmail1").parsley().validate();
		    $("#summaryEditEmail2").parsley().validate();
		    $('#editemail').find('.default').slideDown(200, function(){
			// Do n'thing, just leaving this here for future s'mthings.
		    });
		    gateOpen = false;
		}
		
		if(!$("#summaryEditEmail1").parsley().isValid() || !$("#summaryEditEmail2").parsley().isValid()){
		    gateOpen = false;
		    $('#editemail').addClass('opened');
		    $('#editemail').closest('.editform').addClass('openform');
		    $('#editemail').find('.default').slideDown(200, function(){
			// Do n'thing, just leaving this here for future s'mthings.
		    });
		}
		
		// Check for weak password
		var $passwordField = $(this).find('.strength');
		if($passwordField.length > 0) if($passwordField.hasClass('weak')) gateOpen = false;
		
		var parsleyValid = $(this).parsley().isValid();
		
		if (parsleyValid && gateOpen) {
			var nextStep = $(this).attr('data-nextstep');
			
			if($(this).attr('data-submit')){
			    $('#loadingModal h2').text(jsLanguageLabel.submitLoader);
			    $('#loadingModal').modal({ backdrop: 'static', keyboard: false }); 
			    $(this).ajaxSubmit(function(response) {
				$('#loadingModal').modal('hide'); 
				window.location = response;
			    }); 
			} else {
			    changeStep(nextStep);
			}
		}
	});
}

function onFirstTimeLoginOverviewSubmit(){
	$('.summaryform').each(function(){
		$(this).parsley().on('form:submit', function(formInstance) {
			formInstance.validationResult = false;
			formInstance.submitEvent.preventDefault();
			
			$form = $(formInstance.submitEvent.target);
			$formname = $form.attr('name');
			
			switch ($formname) {
				case 'editpassword':
					//var currentPassword = $form.find('input[name=summaryCurrentPassword]').val();
					var newPassword = $form.find('input[name=summaryEditPassword]').val();
					//$('input[name=ftl_currentpassword]').val(currentPassword);
					$('input[name=ftl_newpassword]').val(newPassword);
					
					closeForm($form);
					break;
				case 'editlanguage':
					var languageVal = $form.find('select[name=language] option:selected').val();
					var languageLabel = $form.find('select[name=language] option:selected').text().trim();
					$('input[name=ftl_preferredlanguage').val(languageVal);
					$('input[name=summaryLanguage]').val(languageLabel);
					
					closeForm($form);
					break;
				case 'editmessaging':
					var correspondenceVal = $form.find('input[name=summaryEditCorrespondence]:checked').val();
					$('input[name=ftl_correspondencetype').val(correspondenceVal);
					if(correspondenceVal == 'email') var summaryReportingValue = byEmail;
					if(correspondenceVal == 'post') var summaryReportingValue = byPostal;
					$('input[name=summaryReporting]').val(summaryReportingValue);
					
					closeForm($form);
					if(correspondenceVal == 'email') {
					    $('#editemail').addClass('opened');
					    $('#editemail').closest('.editform').addClass('openform');
					    $('#editemail').find('.cancel').addClass('hidden');
					    $('#summaryEditEmail1').prop('required',true);
					    $('#summaryEditEmail1').parsley().validate();
					    $('#editemail').find('.default').slideDown(200, function(){
						// Do n'thing, just leaving this here for future s'mthings.
					    });
					}
					if(correspondenceVal == 'post') {
					    $('#editemail').removeClass('opened');
					    $('#editemail').find('.cancel').removeClass('hidden');
					    $('#summaryEditEmail1,#summaryEditEmail2').prop('required',false);
					    $('#summaryEditEmail1').parsley().reset();
					    $('#summaryEditEmail2').parsley().reset();
					    $('#editemail').find('.default').slideUp(200, function(){
						// Do n'thing, just leaving this here for future s'mthings.
					    });
					}
					break;
				case 'editemail':
					var emailVal = $form.find('input[name=summaryEditEmail1]').val();
					$('#summaryEditEmail1').parsley().reset();
					$('#summaryEditEmail2').parsley().reset();
					$('input[name=ftl_email').val(emailVal);
					$('input[name=summaryEmail').val(emailVal);

					closeForm($form);
					break;
				case 'editquestion':
					var personalQuestionId = $('select[name=summaryEditPersonalQuestion] option:selected').val();
					var personalQuestionAnswer = $('input[name=summaryEditPersonalQuestionAnswer]').val();
					var personalQuestionOwn = $('textarea#summaryEditPersonalQuestionOwn').val();
					
					$('input[name=ftl_personalquestionid').val(personalQuestionId);
					$('input[name=ftl_personalquestionanswer').val(personalQuestionAnswer);
					$('input[name=ftl_personalquestionown').val(personalQuestionOwn);
					
					$('input[name=summaryPersonalquestion]').val($('select[name=summaryEditPersonalQuestion] option:selected').text().trim());
					if($('select[name=summaryEditPersonalQuestion] option:selected').val() == '0') $('input[name=summaryPersonalquestion]').val($('textarea#summaryEditPersonalQuestionOwn').val());
					
					closeForm($form);						
					break;
				case 'editsavedata':
					var saveDataVal = $form.find('input[name=summaryEditSavedata]').is(':checked')?true:false;
					//$('input[name=ftl_email').val(saveDataVal);
					
					closeForm($form);
					break;
				default:
			}
			
			return false;
		});
	});
}

function closeForm($form){
	// Remove class to surrounding div
	$(this).closest('.editform').removeClass('openform');
	
	$form.find('.default').slideUp(200, function(){
		$(this).closest('.form').removeClass('opened');
	});
}

function changeStep(stepNumber){
	// Show corresponding step content
	$('.step').addClass('hidden');
	$('.step' + stepNumber).removeClass('hidden');
	
	// Update the step indicator
	$('ol.step-indicator li').removeClass('current');
	if(stepNumber == '4b' || stepNumber == '4c'){
		var step = 4;
	}else{
		var step = +stepNumber;
	}
	var stepIndex = step-1;
	var $currentLi = $('ol.step-indicator li:eq(' + stepIndex + ')');
	$currentLi.prevAll().addClass('complete');
	$currentLi.addClass('current');
	
	// Update the breadcrumbs
	$('#breadcrumb li:last-child').html(stepLabel + step);
	
	// Prefill the overview step when needed
	//if(stepNumber == '7') prefillStep7(); as save data is disabled
	if(stepNumber == '6') prefillStep7(); 
}

function prefillStep7(){
	var email = $('#email1').val();
    var emailOptional = $('#email11').val();
	var currentPassword = $('input[name=currentPassword]').val();
	var newPassword = $('input[name=newPassword]').val();
	var correspondenceType = $('input[name=correspondence]:checked').val();
	var preferredLanguage = $('#taal option:selected').val();
	var personalQuestionId = $('#vraag option:selected').val();
	var personalQuestionAnswer = $('input[name=personalQuestionAnswer]').val();
	var personalQuestionOwn = $('textarea#eigenvraag').val();
	var saveData = $('input[name=savedata]').is(':checked')?true:false;
	
	// Fill hidden inputs
	$('#ftl_email').val(email);
	$('#ftl_currentpassword').val(currentPassword);
	$('#ftl_newpassword').val(newPassword);
	$('#ftl_correspondencetype').val(correspondenceType);
	$('#ftl_preferredlanguage').val(preferredLanguage);
	$('#ftl_personalquestionid').val(personalQuestionId);
	$('#ftl_personalquestionanswer').val(personalQuestionAnswer);
	$('#ftl_personalquestionown').val(personalQuestionOwn);
	$('#ftl_savedata').val(saveData);
	
	// Fill summary showables
	$('input[name=summaryLanguage]').val($('#taal option:selected').text().trim());
	var reportingValue = correspondenceType;
	if(reportingValue == 'email') var summaryReportingValue = byEmail;
	if(reportingValue == 'post') var summaryReportingValue = byPostal;
	$('input[name=summaryReporting]').val(summaryReportingValue);
	/* Check which email field it should use*/
	email = (reportingValue == 'email') ? email : emailOptional;
	$('input[name=summaryEmail]').val(email);
	$('input[name=summaryPersonalquestion]').val($('#vraag option:selected').text().trim());
	if($('#vraag option:selected').val() == '0') $('input[name=summaryPersonalquestion]').val($('input[name=ftl_personalquestionown').val());
	$('input[name=summaryEditSavedata]').prop('checked',saveData);
}